import styled from "styled-components";
import colors from "../../../config/colors";
import { isMobile } from "../../../utils/common";

export const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${colors.darkPrimary}33;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(5px);
`;
export const ModalContent = styled.div`
  width: ${isMobile() ? "95vw" : "80vw"};
  max-height: 80vh;
  box-sizing: border-box;
  background-color: ${colors.background};
  color: ${colors.darkPrimary};
  padding: 10px 20px;
  border-radius: 5px;
  overflow-y: scroll;
  box-shadow: inset rgba(0, 0, 0, 0.2) 0px 18px 50px -10px,
    inset rgba(0, 0, 0, 0.2) 0px -18px 50px -10px; ;
`;
export const Close = styled.img`
  height: 30px;
  width: 30px;
  align-self: ${isMobile() ? "center" : "flex-end"};
  margin-right: ${isMobile() ? "0px" : "10vw"};
  cursor: pointer;
`;
